import type { ConditionalConfig } from '@viapeople/components/src/components/forms/conditionalTypes'
import type { FormInputComponent } from '../types'

export interface DependentComponent {
	id: string
	label: string
	conditionIndices: number[]
}

export function collectSubtreeIds(component: FormInputComponent): string[] {
	const ids: string[] = [component.id]
	if (component.children) {
		for (const child of component.children) {
			ids.push(...collectSubtreeIds(child as FormInputComponent))
		}
	}
	return ids
}

export function findDependentComponents(
	formComponents: FormInputComponent[],
	deletedId: string,
	excludeIds?: Set<string>,
): DependentComponent[] {
	const results: DependentComponent[] = []

	const walk = (components: FormInputComponent[]) => {
		for (const comp of components) {
			if (comp.action === 'delete') continue
			if (excludeIds?.has(comp.id)) continue

			const conditional = (comp.custom as { conditional?: ConditionalConfig }).conditional
			if (conditional) {
				const matchingIndices: number[] = []
				conditional.conditions.forEach((condition, index) => {
					if (condition.sourceComponentId === deletedId) {
						matchingIndices.push(index)
					}
				})
				if (matchingIndices.length > 0) {
					results.push({
						id: comp.id,
						label: comp.label ?? comp.name,
						conditionIndices: matchingIndices,
					})
				}
			}

			if (comp.children) {
				walk(comp.children as FormInputComponent[])
			}
		}
	}

	walk(formComponents)
	return results
}
